(function () {
  'use strict';

  function stars(rating) {
    var n = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function truncate(str, max) {
    var s = String(str || '').replace(/\s+/g, ' ').trim();
    if (s.length <= max) return s;
    return s.slice(0, max).trim() + '…';
  }

  function cardHtml(review) {
    var rating = review.rating || 5;
    var title = review.title || '';
    var body = review.body || '';
    var author = review.author || 'Customer';
    var product = review.product || '';

    return (
      '<article class="vws-jm-card">' +
      '<div class="vws-jm-card__stars">' +
      escapeHtml(stars(rating)) +
      '</div>' +
      (title
        ? '<h3 class="vws-jm-card__title">' + escapeHtml(title) + '</h3>'
        : '') +
      '<p class="vws-jm-card__body">' +
      escapeHtml(truncate(body, 180)) +
      '</p>' +
      '<p class="vws-jm-card__author">' +
      escapeHtml(author) +
      (product ? ' — ' + escapeHtml(product) : '') +
      '</p>' +
      '</article>'
    );
  }

  function ratingFromNode(node) {
    var ratingWrap = node.querySelector('.jdgm-carousel-item__review-rating');
    if (ratingWrap) {
      var label = ratingWrap.getAttribute('aria-label') || '';
      var match = label.match(/(\d+)/);
      if (match) return parseInt(match[1], 10);
    }
    return node.querySelectorAll('.jdgm-star.jdgm--on').length || 5;
  }

  function extractReviewsFromHtml(html) {
    if (!html || typeof html !== 'string') return [];
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    var nodes = wrap.querySelectorAll('.jdgm-carousel-item');
    var out = [];

    nodes.forEach(function (node) {
      var bodyEl = node.querySelector('.jdgm-carousel-item__review-body');
      var titleEl = node.querySelector('.jdgm-carousel-item__review-title');
      var authorEl = node.querySelector('.jdgm-carousel-item__reviewer-name');
      var productEl = node.querySelector('.jdgm-carousel-item__product-image');
      var body = bodyEl ? bodyEl.textContent.trim() : '';
      if (!body) return;

      out.push({
        body: body,
        title: titleEl ? titleEl.textContent.trim() : '',
        author: authorEl ? authorEl.textContent.trim() : 'Customer',
        product: productEl ? productEl.getAttribute('alt') || '' : '',
        rating: ratingFromNode(node)
      });
    });

    return out;
  }

  function reviewsFromPayload(payload) {
    if (!payload) return [];

    if (typeof payload.featured_carousel === 'string') {
      var fromCarousel = extractReviewsFromHtml(payload.featured_carousel);
      if (fromCarousel.length) return fromCarousel;
    }

    if (typeof payload.reviews_tab === 'string') {
      var fromTab = extractReviewsFromHtml(payload.reviews_tab);
      if (fromTab.length) return fromTab;
    }

    if (typeof payload.html === 'string') {
      var fromHtml = extractReviewsFromHtml(payload.html);
      if (fromHtml.length) return fromHtml;
    }

    if (Array.isArray(payload.reviews)) return payload.reviews;
    if (payload.data && Array.isArray(payload.data.reviews)) return payload.data.reviews;

    return [];
  }

  function readConfig(root) {
    var cfg = {
      shop: '',
      token: '',
      perPage: 12,
      autoplay: true,
      autoplaySpeed: 4
    };
    var node = root.querySelector('[data-vws-jm-config]');
    if (node) {
      try {
        var parsed = JSON.parse(node.textContent || '{}');
        cfg.shop = (parsed.shop || '').trim();
        cfg.token = (parsed.token || '').trim();
        cfg.perPage = parseInt(parsed.perPage, 10) || 12;
        cfg.autoplay = parsed.autoplay !== false;
        cfg.autoplaySpeed = parseInt(parsed.autoplaySpeed, 10) || 4;
      } catch (e) {}
    }

    if (!cfg.shop) {
      cfg.shop = (root.getAttribute('data-shop-domain') || '').trim();
    }
    if (!cfg.token) {
      cfg.token = (root.getAttribute('data-public-token') || '').trim();
    }
    if (!cfg.perPage) {
      cfg.perPage = parseInt(root.getAttribute('data-per-page'), 10) || 12;
    }

    if (!cfg.token) {
      try {
        if (window.jdgmSettings && window.jdgmSettings.token) {
          cfg.token = String(window.jdgmSettings.token).trim();
        } else if (window.jdgm && window.jdgm.SETTINGS && window.jdgm.SETTINGS.token) {
          cfg.token = String(window.jdgm.SETTINGS.token).trim();
        }
      } catch (e2) {}
    }

    return cfg;
  }

  function loadReviews(shop, token) {
    var url =
      'https://api.judge.me/api/v1/widgets/featured_carousel?shop_domain=' +
      encodeURIComponent(shop) +
      '&api_token=' +
      encodeURIComponent(token);

    return fetch(url, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('Judge.me request failed');
        return res.json();
      })
      .then(function (json) {
        return reviewsFromPayload(json);
      });
  }

  function clearAutoplay(root) {
    if (root._vwsJmTimer) {
      clearInterval(root._vwsJmTimer);
      root._vwsJmTimer = null;
    }
  }

  function initCarousel(root, force) {
    if (!root) return;
    if (!force && root.getAttribute('data-vws-jm-ready') === 'true') return;

    var track = root.querySelector('[data-vws-jm-track]');
    var prev = root.querySelector('[data-vws-jm-prev]');
    var next = root.querySelector('[data-vws-jm-next]');
    var viewport = root.querySelector('.vws-jm-carousel__viewport');
    if (!track) return;

    var cfg = readConfig(root);
    var shop = cfg.shop;
    var token = cfg.token;
    var perPage = cfg.perPage;

    clearAutoplay(root);

    var state = {
      index: 0,
      track: track,
      autoplay: cfg.autoplay,
      speed: Math.max(2, cfg.autoplaySpeed || 4) * 1000,
      paused: false
    };
    root._vwsJmState = state;

    if (!token) {
      root.removeAttribute('data-vws-jm-ready');
      track.innerHTML =
        '<div class="vws-jm-carousel__status">Add your Judge.me Public API token in this section settings.</div>';
      return;
    }

    if (!shop) {
      root.removeAttribute('data-vws-jm-ready');
      track.innerHTML =
        '<div class="vws-jm-carousel__status">Shop domain missing.</div>';
      return;
    }

    root.setAttribute('data-vws-jm-ready', 'true');
    track.innerHTML =
      '<div class="vws-jm-carousel__status">Loading reviews…</div>';

    function slidesPerView() {
      var w = window.innerWidth || 1200;
      if (w <= 767) return 1;
      if (w <= 991) return 2;
      return 3;
    }

    function maxIndex() {
      var cards = state.track.querySelectorAll('.vws-jm-card');
      if (!cards.length) return 0;
      return Math.max(0, cards.length - slidesPerView());
    }

    function update() {
      var cards = state.track.querySelectorAll('.vws-jm-card');
      if (!cards.length) return;
      var max = maxIndex();
      if (state.index > max) state.index = max;
      if (state.index < 0) state.index = 0;
      var cardWidth = cards[0].getBoundingClientRect().width;
      var styles = window.getComputedStyle(state.track);
      var gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
      var offset = state.index * (cardWidth + gap);
      state.track.style.transform = 'translateX(' + -offset + 'px)';
    }

    function go(delta) {
      var max = maxIndex();
      if (max <= 0) return;
      state.index += delta;
      if (state.index > max) state.index = 0;
      if (state.index < 0) state.index = max;
      update();
    }

    function startAutoplay() {
      clearAutoplay(root);
      if (!state.autoplay) return;
      root._vwsJmTimer = setInterval(function () {
        if (!root._vwsJmState || root._vwsJmState.paused) return;
        if (typeof root._vwsJmGo === 'function') root._vwsJmGo(1);
      }, state.speed);
    }

    root._vwsJmGo = go;
    root._vwsJmUpdate = update;

    function render(reviews) {
      if (!reviews.length) {
        track.innerHTML =
          '<div class="vws-jm-carousel__status">No published reviews found. Re-check the Public API token.</div>';
        return;
      }

      track.innerHTML = reviews
        .slice(0, perPage)
        .map(cardHtml)
        .join('');
      state.index = 0;
      update();
      startAutoplay();
    }

    loadReviews(shop, token)
      .then(render)
      .catch(function () {
        root.removeAttribute('data-vws-jm-ready');
        clearAutoplay(root);
        track.innerHTML =
          '<div class="vws-jm-carousel__status">Could not load reviews. Please try again.</div>';
      });

    if (!root.getAttribute('data-vws-jm-nav')) {
      root.setAttribute('data-vws-jm-nav', 'true');

      if (prev) {
        prev.addEventListener('click', function () {
          if (typeof root._vwsJmGo === 'function') root._vwsJmGo(-1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          if (typeof root._vwsJmGo === 'function') root._vwsJmGo(1);
        });
      }

      if (viewport) {
        viewport.addEventListener('mouseenter', function () {
          if (root._vwsJmState) root._vwsJmState.paused = true;
        });
        viewport.addEventListener('mouseleave', function () {
          if (root._vwsJmState) root._vwsJmState.paused = false;
        });
      }

      window.addEventListener('resize', function () {
        if (typeof root._vwsJmUpdate === 'function') root._vwsJmUpdate();
      });
    }
  }

  function boot(force) {
    document.querySelectorAll('.vws-jm-section').forEach(function (el) {
      initCarousel(el, !!force);
    });

    try {
      if (window.jdgm && typeof window.jdgm.customizeWidgets === 'function') {
        window.jdgm.customizeWidgets();
      }
    } catch (e) {}
  }

  window.vwsJmBoot = boot;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(true);
    });
  } else {
    boot(true);
  }

  document.addEventListener('shopify:section:load', function () {
    boot(true);
  });

  document.addEventListener('shopify:section:select', function () {
    boot(true);
  });
})();
